<template>
	
	<div class="dcpBlock">
		<Sdg v-if="stageType == 'Sdg'"/>
		<Dcp v-else-if="stageType == 'Dcp'"/>
	</div>

</template>

<script>


	import Sdg from './dcp/Sdg.vue';
	import Dcp from './dcp/Dcp.vue';
	import { mapGetters , mapActions } from 'vuex';

	export default {

		components:{
			Sdg,
			Dcp
		},

		computed: {
			...mapGetters(["roundState","blockType","stageType","roundCompleted","roundExplained","roundType"]),
		},


		methods:{
			...mapActions([]),
		}

	}
</script>


// WEBPACK FOOTER //
// src/components/DcpBlock.vue